import React, { useEffect, useRef, useState } from "react";
import "./stylePlans.css";
import { useDispatch, useSelector } from "react-redux";
import { setPathInfo, setPlatformPath } from "../../../redux/commonSlice";
import INCSUBAddPlans from "../../../components/platforms/plans/AddPlans";
import { setIsAddPlan, setPlanInfo, setPlatformList, setPlatformPathRoot } from "../../../features/platforms/platformsSlice";
import { setPlanList, setPlanListLoader } from "../../../features/plans/planSlice";
import { deletePlan, getPlanList, updatePlan } from "../../../services/planServices";
import { toast } from "react-toastify";
import INCSUBSearchbar from "../../../components/common/SearchBar/INCSUBSearchbar";
import { useNavigate } from "react-router";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import ImageTool from "@editorjs/image";

function INCSUBPlan() {
    const dispatch = useDispatch();
    const isAddPlan = useSelector((state) => state.platforms.isAddPlan);
    const platformInfo = useSelector((state) => state.platforms.platformInfo);
    const planList = useSelector((state) => state.plans.planList);
    const navigate = useNavigate();
    const planListLoader = useSelector((state) => state.plans.planListLoader);
    const [selectedPlan, setSelectedPlan] = useState();
    const [isTermsOpen, setIsTermsOpen] = useState(false);
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [isAsk, setIsAsk] = useState(false);
     const platformList = useSelector((state) => state.platforms.platformList);
    const platformPathRoot = useSelector((state) => state.platforms.platformPathRoot);
    const pathInfo = useSelector((state) => state.common.pathInfo);
    const fetchPlanData = async () => {
        dispatch(setPlanListLoader(true));
        try {
            const planData = await getPlanList("", platformInfo.platformId);
            if (planData.status === 200) {
                dispatch(setPlanList(planData.data.data.platformPlanDetailsListDto));
            } else if ([400].includes(planData.status)) {
                toast.error(planData.message);
            } else if (planData.status === 401) {
                navigate("/login");
            }
        } catch (err) {
            toast.error("Something Went Wrong");
        }
        dispatch(setPlanListLoader(false));
    };

    useEffect(() => {
        if (platformInfo) {
            fetchPlanData();
        }
    }, [platformInfo]);

    const editorRefs = useRef({});

    useEffect(() => {
        if (!planList) return;

        planList.forEach((plan) => {
            const editorId = `editor-${plan.platformPlanId}`;
            const existingEditor = editorRefs.current[plan.platformPlanId];
            if (existingEditor) {
                existingEditor.destroy();
                delete editorRefs.current[plan.platformPlanId];
            }

            let parsedDescription;
            try {
                parsedDescription = JSON.parse(plan.planDescription);
            } catch (e) {
                parsedDescription = { blocks: [{ type: "paragraph", data: { text: plan.planDescription } }] };
            }

            setTimeout(() => {
                if (document.getElementById(editorId)) {
                    initializeEditor(editorId, parsedDescription, plan.platformPlanId);
                } else {
                    console.warn(`Editor container ${editorId} not found!`);
                }
            }, 10);
        });

        return () => {
            Object.keys(editorRefs.current).forEach((key) => {
                if (!planList.some((plan) => plan.platformPlanId === key)) {
                    editorRefs.current[key].destroy();
                    delete editorRefs.current[key];
                }
            });
        };
    }, [planList]);


    const initializeEditor = (editorId, parsedDescription, platformPlanId) => {
        if (editorRefs.current[platformPlanId]) {
            return;
        }

        if (document.getElementById(editorId)) {
            editorRefs.current[platformPlanId] = new EditorJS({
                holder: editorId,
                tools: {
                    header: Header,
                    list: List,
                    image: {
                        class: ImageTool,
                        config: {
                            endpoints: {
                                byFile: "http://localhost:3000/uploadFile",
                                byUrl: "http://localhost:3000/fetchUrl",
                            },
                        },
                    },
                },
                data: parsedDescription,
                readOnly: true,
            });
        }
    };

    const [isOpenMenu, setIsOpenmenu] = useState(null);
    const refPlanCardMenu = useRef(null);

    const handleClickOutside = (event) => {

        if (refPlanCardMenu.current && !refPlanCardMenu.current.contains(event.target)) {
            setIsOpenmenu(false);
        }

    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const updatePlanVisible = async (plan) => {
        try {
            const updatedData = {
                platformPlanId: plan.platformPlanId,
                visible: !plan.visible
            }
            const updatePlanData = await updatePlan(updatedData)
            if (updatePlanData?.status === 200) {
                const updatedList = planList.map(plans =>
                    plans.platformPlanId === plan.platformPlanId
                        ? { ...plans, ...updatePlanData.data.data }
                        : plans
                );
                dispatch(setPlanList(updatedList));
            }
            if (updatePlanData?.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login')
                return
            }
            if ([409, 400, 403].includes(updatePlanData?.status)) {
                toast.error(updatePlanData?.data.message);
            }
            dispatch(setIsAddPlan(false))

        } catch (err) {
            toast.error("something went wrong")
        }
    }
    const [categoryLoader, setCategoryLoader] = useState(false)

    const handleDeletePlan = async () => {
        setCategoryLoader(true)
        try {
            const deletedPlanData = await deletePlan(selectedPlan.platformPlanId)
            if (deletedPlanData?.status === 200) {
                const updatedList = planList.filter((plan) => selectedPlan.platformPlanId !== plan.platformPlanId);
                // const updatedList = planList.map(plans =>
                //     plans.platformPlanId === selectedPlan.platformPlanId
                //         ? { ...plans, ...deletedPlanData.data.data }
                //         : plans
                // );
                // dispatch(setPlatformList({
                //     ...platformList,
                //     platformList:{
                //         ...platformList,
                //         planCount:updatedList.length
                //     }
                // }))
                const updatePlatformList =platformList.platformList.map((platfrom)=>platfrom.platformId!==platformInfo.platformId?platfrom:{
                    ...platfrom,
                    planCount:updatedList.length
                })
                dispatch(setPlatformList({
                    ...platformList,
                    platformList:updatePlatformList
                }))
                dispatch(setPlanList(updatedList));

            }
            if (deletedPlanData?.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login');
                return
            }
            if (deletedPlanData?.status === 403) {
                const updatedList = planList.map(plans =>
                    plans.platformPlanId === selectedPlan.platformPlanId
                        ? { ...plans, ...deletedPlanData.data.data }
                        : plans
                );
                dispatch(setPlanList(updatedList));
            }
            if ([409, 400].includes(deletedPlanData?.status)) {
                toast.error(deletedPlanData?.data.message);

            }
            setIsOpenPopup(false);
            setCategoryLoader(false);
        } catch (err) {
            toast.error("something went wrong");
            setCategoryLoader(false)
        }
    }


    return (
        <div className="INCSUBPlan">
            <div className="INCSUBPlan_container">
                <div className="INCSUBPlan_filter_section_container">
                    <div className="INCSUBPlan_filter_section">
                        <div
                            className="INCSUBPlan_filter_section_path_btn"

                        ><svg onClick={() => {
                            dispatch(setPlatformPathRoot(''))
                            dispatch(setPlatformPath('/platforms'))
                        }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <h1>
                                {platformPathRoot} <span className="header_info_indicator">(Plan)</span>
                            </h1>
                        </div>
                    </div>
                    <div className="INCSUBPlan_filter_section_btns_container">
                        <INCSUBSearchbar source={"plans"} placeholder={"Search"} param={{ platformId: platformInfo.platformId }} />
                        <div className="INCSUBPlan_filter_section_btn add_new_Plan" onClick={() => {
                            dispatch(setIsAddPlan(true))
                            setSelectedPlan(null)
                        }}>
                            Add New Plan
                        </div>
                    </div>
                </div>
                <div className="INCSUBPlan_list_section">
                    <div className="INCSUBPlan_list_section_container">
                        {!planListLoader && planList?.length > 0 &&
                            planList.map((plan) => (
                                <div className="INCSUBPlan_card" key={plan.platformPlanId} style={{ cursor: "pointer" }} onClick={() => {
                                    dispatch(setPlatformPath("/platform/plan/pools"))
                                    dispatch(setPlanInfo(plan));
                                    // dispatch(setPathInfo);
                                    dispatch(setPlatformPathRoot(platformPathRoot + ' / ' + plan.planName))
                                }}>
                                    <div className="INCSUBPlan_card_type_container">
                                        <div className="INCSUBPlan_card_type">{plan.planName}</div>
                                        <div className='INCSUBPlan_options_container' onClick={(e)=>e.stopPropagation()}>
                                            <svg onClick={(e) => {
                                                e.stopPropagation();
                                                setIsOpenmenu(plan.platformPlanId)
                                            }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.0003 10.8307C10.4606 10.8307 10.8337 10.4576 10.8337 9.9974C10.8337 9.53716 10.4606 9.16406 10.0003 9.16406C9.54009 9.16406 9.16699 9.53716 9.16699 9.9974C9.16699 10.4576 9.54009 10.8307 10.0003 10.8307Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M10.0003 5.0026C10.4606 5.0026 10.8337 4.62951 10.8337 4.16927C10.8337 3.70903 10.4606 3.33594 10.0003 3.33594C9.54009 3.33594 9.16699 3.70903 9.16699 4.16927C9.16699 4.62951 9.54009 5.0026 10.0003 5.0026Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M10.0003 16.6667C10.4606 16.6667 10.8337 16.2936 10.8337 15.8333C10.8337 15.3731 10.4606 15 10.0003 15C9.54009 15 9.16699 15.3731 9.16699 15.8333C9.16699 16.2936 9.54009 16.6667 10.0003 16.6667Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            {isOpenMenu === plan.platformPlanId ? <div className='menu' ref={refPlanCardMenu}>
                                                <svg onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedPlan(plan)
                                                    dispatch(setIsAddPlan(true))
                                                }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 13.3281H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04886 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <hr />
                                                <svg onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsOpenPopup(true);
                                                    setSelectedPlan(plan);
                                                    setIsAsk(true)
                                                }
                                                } width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 4H3.33333H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12.6668 4.0026V13.3359C12.6668 13.6896 12.5264 14.0287 12.2763 14.2787C12.0263 14.5288 11.6871 14.6693 11.3335 14.6693H4.66683C4.31321 14.6693 3.97407 14.5288 3.72402 14.2787C3.47397 14.0287 3.3335 13.6896 3.3335 13.3359V4.0026M5.3335 4.0026V2.66927C5.3335 2.31565 5.47397 1.97651 5.72402 1.72646C5.97407 1.47641 6.31321 1.33594 6.66683 1.33594H9.3335C9.68712 1.33594 10.0263 1.47641 10.2763 1.72646C10.5264 1.97651 10.6668 2.31565 10.6668 2.66927V4.0026" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6.6665 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.3335 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <hr />
                                                {!plan.visible ? <svg onClick={() => {
                                                    updatePlanVisible(plan)
                                                    // setIsOpenmenu(false)
                                                }} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.2485 5.97656C11.2485 6.5733 11.0115 7.1456 10.5895 7.56755C10.1676 7.98951 9.59527 8.22656 8.99854 8.22656C8.4018 8.22656 7.8295 7.98951 7.40754 7.56755C6.98559 7.1456 6.74854 6.5733 6.74854 5.97656C6.74854 5.37983 6.98559 4.80753 7.40754 4.38557C7.8295 3.96362 8.4018 3.72656 8.99854 3.72656C9.59527 3.72656 10.1676 3.96362 10.5895 4.38557C11.0115 4.80753 11.2485 5.37983 11.2485 5.97656Z" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M1.49902 5.98437C2.69902 2.91162 5.50102 0.734375 8.99902 0.734375C12.497 0.734375 15.299 2.91162 16.499 5.98437C15.299 9.05712 12.497 11.2344 8.99902 11.2344C5.50102 11.2344 2.69902 9.05712 1.49902 5.98437Z" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg> : <svg onClick={() => {
                                                    updatePlanVisible(plan)
                                                    // setIsOpenmenu(false)
                                                }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_81_35113)">
                                                        <path d="M11.9598 11.9574C10.8202 12.8261 9.43258 13.3073 7.99984 13.3307C3.33317 13.3307 0.666504 7.99741 0.666504 7.99741C1.49576 6.45201 2.64593 5.10182 4.03984 4.03741M6.59984 2.82408C7.05873 2.71667 7.52855 2.66297 7.99984 2.66408C12.6665 2.66408 15.3332 7.99741 15.3332 7.99741C14.9285 8.75448 14.4459 9.46724 13.8932 10.1241M9.41317 9.41075C9.23007 9.60724 9.00927 9.76485 8.76394 9.87416C8.51861 9.98347 8.25377 10.0423 7.98523 10.047C7.71669 10.0517 7.44995 10.0023 7.20091 9.90174C6.95188 9.80115 6.72565 9.65143 6.53574 9.46151C6.34582 9.2716 6.1961 9.04537 6.09551 8.79634C5.99492 8.5473 5.94552 8.28056 5.95026 8.01202C5.955 7.74348 6.01378 7.47864 6.12309 7.23331C6.2324 6.98798 6.39001 6.76718 6.5865 6.58408" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M0.666504 0.664062L15.3332 15.3307" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_81_35113">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>


                                                }

                                            </div> : null}
                                        </div>
                                    </div>
                                    <div className="INCSUBPlan_card_plan_info">
                                        <div className="INCSUBPlan_plan_price">₹{plan.planAmount}</div>
                                        <div className="INCSUBPlan_plan_duration">{plan.planDuration} days</div>
                                    </div>
                                    <div className="INCSUBPlan_card_plan_info">
                                        <div className="INCSUBPlan_plan_user_count"><strong>Size:</strong> {plan.allowedMembers} {plan.allowedMembers>1?"members": "member"}</div>
                                    </div>
                                    <hr className="horizontal_line" />
                                    <div className="INCSUBPlan_card_plan_details_info">
                                        <div className="INCSUBPlan_plan__details_heading">Details-</div>
                                        <div id={`editor-${plan.platformPlanId}`} className="editor-container"></div>
                                    </div>
                                    <div className="INCSUBPlan_TearmsandConditions_container" onClick={(e) => e.stopPropagation()}>
                                        <div className="INCSUBPlan_TearmsandConditions_header_content">
                                            <div className="INCSUBPlan_TearmsandConditions_header">Terms & Conditions</div>
                                            <div className="INCSUBPlan_arrow_holder">{isTermsOpen === plan.platformPlanId ? <svg onClick={(e) => {
                                                e.stopPropagation();
                                                setIsTermsOpen(false)
                                            }} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L7 7L13 1" stroke="black" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                                : <svg onClick={(e) => {
                                                    e.stopPropagation()
                                                    setIsTermsOpen(plan.platformPlanId)
                                                }} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 7L7 1L13 7" stroke="black" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }</div>
                                        </div>
                                        {isTermsOpen === plan.platformPlanId ? <div className="INCSUBPlan_tandc_details">
                                            {plan.planTermsCondition.split('\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </div> : null}
                                    </div>
                                </div>
                            ))
                        }
                        {
                            !planListLoader && planList?.length < 1 && <div className="INCSUBPlan_empty"> No Plan Added Yet </div>
                        }
                    </div>
                </div>
                {isAddPlan && <INCSUBAddPlans plan={selectedPlan} />}
                {isOpenPopUp ?
                    <div className='INCSUBCategory_permission_popup'>{
                        isAsk ?
                            <div className='INCSUBCategory_ask_container' >
                                <div className='INCSUBCategory_ask' style={{ display: categoryLoader ? 'none' : null }}>
                                    <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                                        <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                                        <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                                        <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                                        <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                                        <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                        <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                        <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                        <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    </svg>

                                    <div className='INCSUBCategory_permission_header'>
                                        Are you sure to delete this Plan?
                                    </div>
                                    <div className='INCSUBCategory_permission_btn_container'>
                                        <div className="INCSUBCategory_image_upload_btn">
                                            <div className='INCSUBCategory_upload_btn' onClick={() => handleDeletePlan()} disabled={categoryLoader}>Delete</div>
                                            <div className='upload_cancel_btn' onClick={() => {
                                                setIsOpenPopup(false);
                                                setSelectedPlan(null);
                                                setIsAsk(false);
                                            }}>Cancel</div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    categoryLoader ? <div className='categoryloader' /> : null
                                }
                            </div> : <div className='INCSUBCategory_ask_container'>
                                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                    <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                </svg>
                                <div className='INCSUBCategory_permission_header'>
                                    Can’t delete
                                </div>
                                <div className='INCSUBCategory_permission_text'>There are platforms in this category.</div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className='INCSUBCategory_upload_btn' onClick={() => {
                                            setIsOpenPopup(false)
                                            setSelectedPlan(null)
                                        }}>Ok, Got it</div>
                                        {/* <div className='upload_cancel_btn'>Cancel</div> */}
                                    </div>
                                </div>
                            </div>
                    }


                    </div> : null
                }
            </div>
        </div >
    );
}

export default INCSUBPlan;
